/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { has } from '@utils/lodash';

export function isAxiosError(err: any) {
  return has(err, 'response.status');
}

// https://github.com/axios/axios/blob/v0.18.0/lib/adapters/xhr.js#L87
export function isNetworkError(err: any) {
  return err.message === 'Network Error';
}

// https://github.com/axios/axios/blob/v0.18.0/lib/adapters/xhr.js#L95
export function isTimeoutError(err: any) {
  return err.code === 'ECONNABORTED';
}
